// extracted by mini-css-extract-plugin
module.exports = {"user-photo":"UserPhoto_user-photo__-jx4L","user-photo-svg-fa":"UserPhoto_user-photo-svg-fa__TpVXF"};